"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDraftPurchaseOrdersSchema = exports.generateDraftPurchaseOrdersLineSchema = exports.convertToPurchaseOrderSchema = exports.convertToPurchaseOrderLineSchema = exports.rejectPurchaseRequisitionSchema = exports.createPurchaseRequisitionSchema = exports.purchaseRequisitionLineSchema = exports.purchaseRequisitionLineShape = exports.REQUISITION_URGENCY_LEVELS = void 0;
const zod_1 = require("zod");
exports.REQUISITION_URGENCY_LEVELS = ['ROUTINE', 'URGENT', 'EMERGENCY'];
exports.purchaseRequisitionLineShape = {
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    requestedQuantity: zod_1.z.number().positive(),
    remarks: zod_1.z.string().optional(),
    sortOrder: zod_1.z.number().int().nonnegative().optional(),
};
exports.purchaseRequisitionLineSchema = zod_1.z.object(exports.purchaseRequisitionLineShape);
exports.createPurchaseRequisitionSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    requestingLocationId: zod_1.z.string().uuid(),
    urgency: zod_1.z.enum(exports.REQUISITION_URGENCY_LEVELS).optional(),
    remarks: zod_1.z.string().optional(),
    lines: zod_1.z.array(exports.purchaseRequisitionLineSchema).min(1),
});
exports.rejectPurchaseRequisitionSchema = zod_1.z.object({ reason: zod_1.z.string().min(1) });
exports.convertToPurchaseOrderLineSchema = zod_1.z.object({
    requisitionLineId: zod_1.z.string().uuid(),
    unitPrice: zod_1.z.number().int().nonnegative(),
});
exports.convertToPurchaseOrderSchema = zod_1.z.object({
    vendorId: zod_1.z.string().uuid(),
    poDate: zod_1.z.coerce.date(),
    expectedDeliveryDate: zod_1.z.coerce.date().optional(),
    deliveryLocationId: zod_1.z.string().uuid().optional(),
    paymentTermsDays: zod_1.z.number().int().positive().optional(),
    deliveryTerms: zod_1.z.string().optional(),
    freightTerms: zod_1.z.string().optional(),
    remarks: zod_1.z.string().optional(),
    lines: zod_1.z.array(exports.convertToPurchaseOrderLineSchema).min(1),
});
exports.generateDraftPurchaseOrdersLineSchema = zod_1.z.object({
    requisitionLineId: zod_1.z.string().uuid(),
    vendorId: zod_1.z.string().uuid(),
    unitPrice: zod_1.z.number().int().nonnegative(),
});
exports.generateDraftPurchaseOrdersSchema = zod_1.z.object({
    poDate: zod_1.z.coerce.date(),
    deliveryLocationId: zod_1.z.string().uuid().optional(),
    lines: zod_1.z.array(exports.generateDraftPurchaseOrdersLineSchema).min(1),
});
//# sourceMappingURL=purchase-requisition.schema.js.map